// Phase RV-5 — Upcoming Picks Board page (premium editorial).
//
// Public, anon-readable. No AppShell. Rewired to the Football Products
// design kit (FpHead) — all chrome comes from the `.fp` scoped layer.
// Neutral surfaces only; accent reserved for typography + live indicators.

import type { CSSProperties } from "react";
import { Link } from "react-router-dom";
import { UpcomingPicksBoard } from "../../components/rollover-extras/UpcomingPicksBoard.tsx";
import { useAuthSession } from "../../auth/useAuthSession.ts";
import { DoctrineSection } from "../../components/DoctrineSection.tsx";
import { useDoctrinePicks } from "../../doctrine/useDoctrinePicks.ts";
import { FpHead, FpSeam } from "../football/_fpkit.tsx";

const footerLink: CSSProperties = {
  fontFamily: "var(--font-mono)",
  fontSize: 11,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: "var(--fp-accent-text)",
  textDecoration: "none",
};

export function RolloverUpcomingPage(): JSX.Element {
  const { user } = useAuthSession();
  const {
    probabilityPicks: doctrineProbPicks,
    valuePicks: doctrineValuePicks,
    substrateEmpty,
    substrateWeek,
  } = useDoctrinePicks({ t1HasPicks: false });
  return (
    <div className="fp" data-screen-label="03 ROLLOVER · UPCOMING">
      <FpHead
        kicker="STRIKZA · ROLLOVER"
        title="Upcoming Picks Board"
      />
      <p
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: 12,
          letterSpacing: "0.01em",
          color: "var(--text-tertiary)",
          lineHeight: 1.6,
          maxWidth: 640,
          margin: "0 0 4px",
        }}
      >
        The legs the 6-stage pipeline locked for this window — published before
        kickoff, free to inspect. Selected legs lead each tier; the full agent
        log unlocks with Pro.
      </p>

      <UpcomingPicksBoard />

      <DoctrineSection
        probabilityPicks={doctrineProbPicks}
        valuePicks={doctrineValuePicks}
        isFullFallback={false}
        substrateEmpty={substrateEmpty}
        substrateWeek={substrateWeek}
      />

      <FpSeam />

      <footer
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          paddingTop: 4,
        }}
      >
        {user ? (
          <Link to="/rollover" style={footerLink}>
            ← Back to your chain
          </Link>
        ) : (
          <Link to="/auth" style={footerLink}>
            Start a chain — sign up to play →
          </Link>
        )}
      </footer>
    </div>
  );
}
